import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import BrandLogo from '../../../components/BrandLogo'
import CookieBanner from '../../../components/CookieBanner'

export default function OnboardingShell({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string
  subtitle?: string
  children: ReactNode
  footer?: ReactNode
}) {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-sm ds-enter">
          <div className="mb-10">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-5 h-5 bg-[#FF2300] rounded-sm flex-shrink-0"></div>
              <BrandLogo className="h-3 w-auto text-gray-900 dark:text-white" />
            </div>
            <div className="text-sm text-gray-900 dark:text-white/90 mb-2">{title}</div>
            {subtitle ? <div className="text-xs text-gray-500">{subtitle}</div> : null}
            {footer ? <div className="text-xs text-gray-500 mt-2">{footer}</div> : null}
          </div>

          <div>{children}</div>
        </div>
      </div>

      {/* Footer with legal links */}
      <footer className="py-6 px-6">
        <div className="max-w-sm mx-auto flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs text-gray-500">
          <Link to="/privacy-policy" className="hover:text-gray-900 dark:hover:text-white transition-colors">
            Privacy
          </Link>
          <Link to="/terms-of-service" className="hover:text-gray-900 dark:hover:text-white transition-colors">
            Terms
          </Link>
          <Link to="/accessibility-statement" className="hover:text-gray-900 dark:hover:text-white transition-colors">
            Accessibility
          </Link>
        </div>
      </footer>
      
      {/* Cookie Banner */}
      <CookieBanner />
    </div>
  )
}

